import {
  property,
  subclass,
} from "@arcgis/core/core/accessorSupport/decorators";
import { messageBundle, tsx } from "@arcgis/core/widgets/support/widget";
import Widget from "@arcgis/core/widgets/Widget";
import { VNode } from "../../interfaces/interfaces";
import { EAppTemplateType } from "templates-common-library/baseClasses/CompatibilityChecker";

import t9nAppMessages from "../../t9n/App/App.json";
import "./InfoBadge/InfoBadge.scss";

@subclass("Landing.widgets.InfoBadge")
export default class InfoBadge extends Widget {
  @property()
  badge: string;

  @property()
  appType: EAppTemplateType;

  @property()
  uniqueId: string;

  @property()
  overrideTooltip: string;

  @property()
  disableTooltip: boolean = false;

  @property()
  @messageBundle("dist/assets/t9n/App/App")
  appMessages: typeof t9nAppMessages;

  @property()
  typeStamp: "grid" | "detailed" = "grid";

  @property()
  timeStamp: string = new Date().toISOString();

  constructor(props) {
    super(props);
  }

  renderWrapper(type: "grid" | "detailed", timeStamp: string): VNode {
    this.typeStamp = type;
    this.timeStamp = timeStamp;
    return this.render();
  }

  render() {
    const uniqueId = `${this.uniqueId}--${this.typeStamp}--${this.timeStamp}`;
    const wrapperId = `infoBdg-wrapper-${uniqueId}`;
    const tooltipId = `infoBdg-tooltip-${uniqueId}`;
    const content = this.renderTooltip();
    return (
      <div key={wrapperId}>
        {this.disableTooltip ? null : (
          <calcite-tooltip
            class="info-badge-tooltip"
            key={tooltipId}
            label={content}
            reference-element={uniqueId}
            placement="top"
          >
            {content}
          </calcite-tooltip>
        )}
        <calcite-chip
          tabindex="0"
          scale="s"
          appearance="solid"
          key={uniqueId}
          id={uniqueId}
          class={this.classes("badge", `badge--${this.badge}`)}
        >
          {this.appMessages.appBadges[this.badge]}
        </calcite-chip>
      </div>
    );
  }

  renderTooltip(): string {
    if (this.overrideTooltip != null) {
      return this.overrideTooltip;
    }
    const updatedTip = this.appMessages.appBadgeToolTips.Updated[this.appType];
    const genericUpdatedTip = this.appMessages.appBadgeToolTips.Updated.generic;
    return this.badge !== "Updated"
      ? this.appMessages.appBadgeToolTips[this.badge]
      : updatedTip != null
      ? updatedTip
      : genericUpdatedTip;
  }
}
